import i18nFactory from '@yandex-int/i18n';

import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { GdAdPriceCurrency } from '../../typings/graphql-grid';

import * as keyset from './CurrencyHelper.i18n';

const i18n = i18nFactory(keyset);

export class CurrencyHelper {
    static getCurrencyOptions(
        filterCurrency?: Array<GdAdPriceCurrency>
    ): Array<{
        text: string;
        val: string;
    }> {
        return [
            [GdAdPriceCurrency.BYN, i18n('BYN')],
            [GdAdPriceCurrency.USD, i18n('USD')],
            [GdAdPriceCurrency.EUR, i18n('EUR')],
            [GdAdPriceCurrency.KZT, i18n('KZT')],
            [GdAdPriceCurrency.RUB, i18n('RUB')],
            [GdAdPriceCurrency.TRY, i18n('TRY')],
            [GdAdPriceCurrency.UZS, i18n('UZS')],
            [GdAdPriceCurrency.UAH, i18n('UAH')],
            [GdAdPriceCurrency.CHF, i18n('CHF')]
        ]
            .filter(cur => {
                return !(filterCurrency && filterCurrency.some(filterCur => filterCur === cur[0]));
            })
            .map(([cur, text]: [GdAdPriceCurrency, string]) => ({
                val: cur,
                text: `${mapStringToCurrencySymbol(cur)} \u2014 ${text}`
            }));
    }
}
